export const INVALID_CREDENTIALS_ERROR_MSG =
	"Username and password combination is incorrect. Please check your credentials and try again.";
export const GENERIC_ERROR_MSG = "A problem has occurred";
